module.exports = __webpack_public_path__ + "img/coupon-sp.34e110d0.png";